import type { ComponentProps } from 'react';

import { Label } from './label';
import { CircleAlertIcon } from 'lucide-react';
import { cn } from './helpers';

export const CustomErrorMessage = ({
  children,
  className,
  icon,
  ...props
}: ComponentProps<typeof Label> & { icon?: React.ReactNode }) => {
  return (
    <Label
      className={cn(
        'text-destructive gap-1 flex items-center mt-2 text-xs mb-0 font-normal',
        className
      )}
      {...props}
    >
      {icon ? (
        icon
      ) : (
        <CircleAlertIcon
          className='shrink-0'
          size={14}
        />
      )}
      {children}
    </Label>
  );
};
